import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { useShowNotification } from 'js/components/common/Notifications';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { forgotUsername } from './server';

export const useForgotUsername = () => {
    const translate = useComponentTranslations();
    const showNotification = useShowNotification({
        iconType: 'info',
        message: translate('successMessage')
    });
    const getErrorMessage = useGetErrorMessage();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async function process({
        data,
        validationToken,
        requestReCaptchaToken
    }) {
        const {
            birthdate,
            email
        } = data;

        try {
            await forgotUsername({
                ...validationToken ? { token: validationToken } : {},
                ...birthdate ? { verificationBirthDate: birthdate } : {},
                email,
                casinoName
            });
            showNotification();
            publicEventsAPIService.trigger('forgotUsername:success');
        } catch (error) {
            const { data: { errorCode } = {} } = error?.response || error || {};
            const errorMsg = getErrorMessage(error);

            if (errorCode === 301) {
                try {
                    const { token } = await requestReCaptchaToken();

                    return await process({
                        data,
                        requestReCaptchaToken,
                        validationToken: token
                    });
                } catch (validationError) {
                    publicEventsAPIService.trigger('forgotUsername:fail');

                    return errorMsg;
                }
            }

            publicEventsAPIService.trigger('forgotUsername:fail');

            return errorMsg;
        }
    }, [
        casinoName,
        getErrorMessage,
        showNotification
    ]);
};
